import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, TermFilter, FilterOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/teachers/TeachersAction";
import { useTeachersUIContext } from "../TeachersUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, tcKimlikNo, name, surname, branchId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, branchId };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function TeachersFilter() {
  // Teachers UI Context
  const teachersUIContext = useTeachersUIContext();
  const teachersUIProps = useMemo(() => {
    return {
      setQueryParams: teachersUIContext.setQueryParams,
      queryParams: teachersUIContext.queryParams,
    };
  }, [teachersUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, branches } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      branches: state.teachers.branches
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getBranches());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(teachersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, teachersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      teachersUIProps.setQueryParams(newQueryParams);
    }
  };

  const branchOptions = FilterOptions.concat(branches);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        tcKimlikNo: "",
        name: "",
        surname: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">            
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={branchOptions}
                value={values.branchId}
                placeholder="Branşı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("branchId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Branşı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}